import { useRef } from "react";

import { config } from "../../config";
import Brandmark from "./Brandmark";
import { MenuIcon } from "./LandingIcons";

interface LandingHeaderProps {
  onRequestAccess: () => void;
}

const NAV_ITEMS = [
  ["Platform", "#platform"],
  ["Workflow", "#workflow"],
  ["Proof", "#proof"],
  ["Readiness", "#readiness"],
] as const;

export default function LandingHeader({ onRequestAccess }: LandingHeaderProps) {
  const loginHref = `${config.appBaseUrl || ""}/login`;
  const mobileMenuRef = useRef<HTMLDetailsElement | null>(null);
  const closeMobileMenu = () => {
    if (mobileMenuRef.current) mobileMenuRef.current.open = false;
  };
  const closeMobileMenuAndFocus = (href: string) => () => {
    closeMobileMenu();
    window.requestAnimationFrame(() => {
      const target = document.querySelector<HTMLElement>(href);
      if (!target) return;
      target.setAttribute("tabindex", "-1");
      target.addEventListener("blur", () => target.removeAttribute("tabindex"), {
        once: true,
      });
      target.focus({ preventScroll: true });
    });
  };

  return (
    <header className="oc-site-header">
      <div className="oc-site-shell oc-site-header__inner">
        <a className="oc-site-brand" href="#top" aria-label="OrbitCell home">
          <Brandmark size={38} ariaLabel="OrbitCell" />
          <span className="oc-site-brand__copy">
            <strong>OrbitCell</strong>
            <span>
              a{" "}
              <span className="oc-site-brand__parent">JoatLabs.dev</span>{" "}
              platform
            </span>
          </span>
        </a>

        <nav className="oc-site-nav" aria-label="Landing page">
          {NAV_ITEMS.map(([label, href]) => (
            <a key={href} href={href}>
              {label}
            </a>
          ))}
        </nav>

        <div className="oc-site-header__actions">
          <a className="oc-site-signin" href={loginHref}>
            Sign in
          </a>
          <button
            className="oc-button oc-button--primary oc-site-header__cta"
            type="button"
            onClick={onRequestAccess}
          >
            Request access
          </button>
          <details className="oc-site-menu" ref={mobileMenuRef}>
            <summary aria-label="Open navigation">
              <MenuIcon />
            </summary>
            <nav aria-label="Mobile landing page">
              {NAV_ITEMS.map(([label, href]) => (
                <a key={href} href={href} onClick={closeMobileMenuAndFocus(href)}>
                  {label}
                </a>
              ))}
              <a href={loginHref} onClick={closeMobileMenu}>Sign in</a>
            </nav>
          </details>
        </div>
      </div>
    </header>
  );
}
